import styled from 'styled-components'

export const OutlineContainer = styled.div`
width: 100%;
border-radius: .25rem;
padding: .5rem .75rem;
display: flex;
flex-direction: column;
border: 2px solid var(--${props => props.theme});
`

export const ContainerFiltro = styled.div`
display: flex;
align-items: center;
background-color: white;
border-radius: 8px;
width: 100%;
`
